export const TYPE_COLOR = 'color';
export const TYPE_SIZE = 'size';

export const VARIABLE_TYPES = [TYPE_COLOR, TYPE_SIZE];
